enum OrderStateEnum {
  ACTIVE = 'Active',
  ON_HOLD = 'OnHold',
}

export default OrderStateEnum;
